export enum SpvStatus {
  EDITING = 'EDITING',
  PAID = 'PAID',
  VALIDATED = 'VALIDATED',
  SIGNED = 'SIGNED',
  VERIFIED = 'VERIFIED',
  CREATING = 'CREATING',
}
